import React from 'react';

import {
  CardSupportingText
} from 'rmwc/Card';

function Display(props) {
  return (
    <CardSupportingText className="mdc-calc-display">
      <span className="mdc-calc-entry mdc-calc__allow-select">{props.entry}</span>
      <span className="mdc-calc-ans mdc-calc__allow-select">{props.ans}</span>
    </CardSupportingText>
  );
}

export default Display;



// WEBPACK FOOTER //
// ./src/MDCCalc/Display.js